export function Divider(props) {
  const { size } = props
  return (<div style={{ height: `${size ?? 1}em` }}/>)
}